import { api } from '@/lib/api';
import type { BalanceSheetReport } from './types';

export async function fetchBalanceSheet(asOf: string): Promise<BalanceSheetReport> {
  return api.get<BalanceSheetReport>('/v4/balance-sheet', { asOf });
}

export async function clearBalanceSheetCache(asOf: string): Promise<{ cleared: number }> {
  return api.delete<{ cleared: number }>(`/v4/balance-sheet/cache?asOf=${encodeURIComponent(asOf)}`);
}

/** Today's date (YYYY-MM-DD) in America/Montreal. */
export function todayMontreal(): string {
  // en-CA renders as ISO-like YYYY-MM-DD
  return new Date().toLocaleDateString('en-CA', { timeZone: 'America/Montreal' });
}

export interface MonthEnd {
  month: string; // 'YYYY-MM'
  label: string; // 'May 2026'
  asOf: string; // 'YYYY-MM-DD' (last day of month)
}

/**
 * Build a list of month-end dates for the last `months` months (ascending,
 * oldest → newest). Each entry's `asOf` is the last calendar day of that month.
 */
export function buildMonthEnds(months: number): MonthEnd[] {
  const today = new Date();
  const results: MonthEnd[] = [];
  for (let i = 0; i < months; i++) {
    const date = new Date(today.getFullYear(), today.getMonth() - i, 1);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const pad = String(month).padStart(2, '0');
    const lastDay = new Date(year, month, 0).getDate();
    const asOf = `${year}-${pad}-${String(lastDay).padStart(2, '0')}`;
    const label = date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
    results.push({ month: `${year}-${pad}`, label, asOf });
  }
  results.sort((a, b) => a.month.localeCompare(b.month));
  return results;
}
